/**
 * Nakshatra and Rashi Data
 * Complete Nakshatra data as per Shatabdi Panchang standards
 */

// Complete Nakshatra data (27 Nakshatras)
export const NAKSHATRA_DATA = [
  { name: 'Ashwini', nameHi: 'अश्विनी', nameTe: 'అశ్విని', lord: 'Ketu', deity: 'Ashwini Kumaras', rashi: 'Aries', syllables: ['Chu', 'Che', 'Cho', 'La'], symbol: '🐴' },
  { name: 'Bharani', nameHi: 'भरणी', nameTe: 'భరణి', lord: 'Venus', deity: 'Yama', rashi: 'Aries', syllables: ['Li', 'Lu', 'Le', 'Lo'], symbol: '🔺' },
  { name: 'Krittika', nameHi: 'कृत्तिका', nameTe: 'కృత్తిక', lord: 'Sun', deity: 'Agni', rashi: 'Aries/Taurus', syllables: ['A', 'I', 'U', 'E'], symbol: '🔥' },
  { name: 'Rohini', nameHi: 'रोहिणी', nameTe: 'రోహిణి', lord: 'Moon', deity: 'Brahma', rashi: 'Taurus', syllables: ['O', 'Va', 'Vi', 'Vu'], symbol: '🐂' },
  { name: 'Mrigashira', nameHi: 'मृगशिरा', nameTe: 'మృగశిర', lord: 'Mars', deity: 'Soma', rashi: 'Taurus/Gemini', syllables: ['Ve', 'Vo', 'Ka', 'Ki'], symbol: '🦌' },
  { name: 'Ardra', nameHi: 'आर्द्रा', nameTe: 'ఆర్ద్ర', lord: 'Rahu', deity: 'Rudra', rashi: 'Gemini', syllables: ['Ku', 'Gha', 'Ng', 'Chha'], symbol: '💧' },
  { name: 'Punarvasu', nameHi: 'पुनर्वसु', nameTe: 'పునర్వసు', lord: 'Jupiter', deity: 'Aditi', rashi: 'Gemini/Cancer', syllables: ['Ke', 'Ko', 'Ha', 'Hi'], symbol: '🏹' },
  { name: 'Pushya', nameHi: 'पुष्य', nameTe: 'పుష్యమి', lord: 'Saturn', deity: 'Brihaspati', rashi: 'Cancer', syllables: ['Hu', 'He', 'Ho', 'Da'], symbol: '🌸' },
  { name: 'Ashlesha', nameHi: 'आश्लेषा', nameTe: 'ఆశ్లేష', lord: 'Mercury', deity: 'Nagas', rashi: 'Cancer', syllables: ['Di', 'Du', 'De', 'Do'], symbol: '🐍' },
  { name: 'Magha', nameHi: 'मघा', nameTe: 'మఘ', lord: 'Ketu', deity: 'Pitrus', rashi: 'Leo', syllables: ['Ma', 'Mi', 'Mu', 'Me'], symbol: '👑' },
  { name: 'Purva Phalguni', nameHi: 'पूर्व फाल्गुनी', nameTe: 'పుబ్బ', lord: 'Venus', deity: 'Bhaga', rashi: 'Leo', syllables: ['Mo', 'Ta', 'Ti', 'Tu'], symbol: '🛏️' },
  { name: 'Uttara Phalguni', nameHi: 'उत्तर फाल्गुनी', nameTe: 'ఉత్తర', lord: 'Sun', deity: 'Aryaman', rashi: 'Leo/Virgo', syllables: ['Te', 'To', 'Pa', 'Pi'], symbol: '☀️' },
  { name: 'Hasta', nameHi: 'हस्त', nameTe: 'హస్త', lord: 'Moon', deity: 'Savitar', rashi: 'Virgo', syllables: ['Pu', 'Sha', 'Na', 'Tha'], symbol: '✋' },
  { name: 'Chitra', nameHi: 'चित्रा', nameTe: 'చిత్త', lord: 'Mars', deity: 'Tvashtar', rashi: 'Virgo/Libra', syllables: ['Pe', 'Po', 'Ra', 'Ri'], symbol: '💎' },
  { name: 'Swati', nameHi: 'स्वाति', nameTe: 'స్వాతి', lord: 'Rahu', deity: 'Vayu', rashi: 'Libra', syllables: ['Ru', 'Re', 'Ro', 'Ta'], symbol: '🌬️' },
  { name: 'Vishakha', nameHi: 'विशाखा', nameTe: 'విశాఖ', lord: 'Jupiter', deity: 'Indra-Agni', rashi: 'Libra/Scorpio', syllables: ['Ti', 'Tu', 'Te', 'To'], symbol: '🌳' },
  { name: 'Anuradha', nameHi: 'अनुराधा', nameTe: 'అనూరాధ', lord: 'Saturn', deity: 'Mitra', rashi: 'Scorpio', syllables: ['Na', 'Ni', 'Nu', 'Ne'], symbol: '⭐' },
  { name: 'Jyeshtha', nameHi: 'ज्येष्ठा', nameTe: 'జ్యేష్ఠ', lord: 'Mercury', deity: 'Indra', rashi: 'Scorpio', syllables: ['No', 'Ya', 'Yi', 'Yu'], symbol: '👂' },
  { name: 'Mula', nameHi: 'मूल', nameTe: 'మూల', lord: 'Ketu', deity: 'Nirriti', rashi: 'Sagittarius', syllables: ['Ye', 'Yo', 'Bha', 'Bhi'], symbol: '🌿' },
  { name: 'Purva Ashadha', nameHi: 'पूर्वाषाढ़ा', nameTe: 'పూర్వాషాఢ', lord: 'Venus', deity: 'Apas', rashi: 'Sagittarius', syllables: ['Bhu', 'Dha', 'Pha', 'Da'], symbol: '🌊' },
  { name: 'Uttara Ashadha', nameHi: 'उत्तराषाढ़ा', nameTe: 'ఉత్తరాషాఢ', lord: 'Sun', deity: 'Vishwadevas', rashi: 'Sagittarius/Capricorn', syllables: ['Bhe', 'Bho', 'Ja', 'Ji'], symbol: '🐘' },
  { name: 'Shravana', nameHi: 'श्रवण', nameTe: 'శ్రవణం', lord: 'Moon', deity: 'Vishnu', rashi: 'Capricorn', syllables: ['Ju', 'Je', 'Jo', 'Gha'], symbol: '👂' },
  { name: 'Dhanishta', nameHi: 'धनिष्ठा', nameTe: 'ధనిష్ఠ', lord: 'Mars', deity: 'Vasus', rashi: 'Capricorn/Aquarius', syllables: ['Ga', 'Gi', 'Gu', 'Ge'], symbol: '🥁' },
  { name: 'Shatabhisha', nameHi: 'शतभिषा', nameTe: 'శతభిషం', lord: 'Rahu', deity: 'Varuna', rashi: 'Aquarius', syllables: ['Go', 'Sa', 'Si', 'Su'], symbol: '💯' },
  { name: 'Purva Bhadrapada', nameHi: 'पूर्व भाद्रपद', nameTe: 'పూర్వాభాద్ర', lord: 'Jupiter', deity: 'Aja Ekapada', rashi: 'Aquarius/Pisces', syllables: ['Se', 'So', 'Da', 'Di'], symbol: '⚡' },
  { name: 'Uttara Bhadrapada', nameHi: 'उत्तर भाद्रपद', nameTe: 'ఉత్తరాభాద్ర', lord: 'Saturn', deity: 'Ahir Budhnya', rashi: 'Pisces', syllables: ['Du', 'Tha', 'Jha', 'Da'], symbol: '🌙' },
  { name: 'Revati', nameHi: 'रेवती', nameTe: 'రేవతి', lord: 'Mercury', deity: 'Pushan', rashi: 'Pisces', syllables: ['De', 'Do', 'Cha', 'Chi'], symbol: '🐟' },
];

// Rashi (Moon Sign) data with nakshatra mapping
export const RASHI_DATA = [
  { name: 'Mesha', english: 'Aries', nameHi: 'मेष', nameTe: 'మేషం', lord: 'Mars', nakshatras: ['Ashwini', 'Bharani', 'Krittika (1)'] },
  { name: 'Vrishabha', english: 'Taurus', nameHi: 'वृषभ', nameTe: 'వృషభం', lord: 'Venus', nakshatras: ['Krittika (2-4)', 'Rohini', 'Mrigashira (1-2)'] },
  { name: 'Mithuna', english: 'Gemini', nameHi: 'मिथुन', nameTe: 'మిథునం', lord: 'Mercury', nakshatras: ['Mrigashira (3-4)', 'Ardra', 'Punarvasu (1-3)'] },
  { name: 'Karka', english: 'Cancer', nameHi: 'कर्क', nameTe: 'కర్కాటకం', lord: 'Moon', nakshatras: ['Punarvasu (4)', 'Pushya', 'Ashlesha'] },
  { name: 'Simha', english: 'Leo', nameHi: 'सिंह', nameTe: 'సింహం', lord: 'Sun', nakshatras: ['Magha', 'Purva Phalguni', 'Uttara Phalguni (1)'] },
  { name: 'Kanya', english: 'Virgo', nameHi: 'कन्या', nameTe: 'కన్య', lord: 'Mercury', nakshatras: ['Uttara Phalguni (2-4)', 'Hasta', 'Chitra (1-2)'] },
  { name: 'Tula', english: 'Libra', nameHi: 'तुला', nameTe: 'తుల', lord: 'Venus', nakshatras: ['Chitra (3-4)', 'Swati', 'Vishakha (1-3)'] },
  { name: 'Vrishchika', english: 'Scorpio', nameHi: 'वृश्चिक', nameTe: 'వృశ్చికం', lord: 'Mars', nakshatras: ['Vishakha (4)', 'Anuradha', 'Jyeshtha'] },
  { name: 'Dhanu', english: 'Sagittarius', nameHi: 'धनु', nameTe: 'ధనుస్సు', lord: 'Jupiter', nakshatras: ['Mula', 'Purva Ashadha', 'Uttara Ashadha (1)'] },
  { name: 'Makara', english: 'Capricorn', nameHi: 'मकर', nameTe: 'మకరం', lord: 'Saturn', nakshatras: ['Uttara Ashadha (2-4)', 'Shravana', 'Dhanishta (1-2)'] },
  { name: 'Kumbha', english: 'Aquarius', nameHi: 'कुम्भ', nameTe: 'కుంభం', lord: 'Saturn', nakshatras: ['Dhanishta (3-4)', 'Shatabhisha', 'Purva Bhadrapada (1-3)'] },
  { name: 'Meena', english: 'Pisces', nameHi: 'मीन', nameTe: 'మీనం', lord: 'Jupiter', nakshatras: ['Purva Bhadrapada (4)', 'Uttara Bhadrapada', 'Revati'] },
];

/**
 * Get Nakshatra by index
 * @param {number} index - Nakshatra index (0-26)
 * @returns {Object} Nakshatra data
 */
export const getNakshatraByIndex = (index) => {
  return NAKSHATRA_DATA[index % 27];
};

/**
 * Get Rashi by index
 * @param {number} index - Rashi index (0-11)
 * @returns {Object} Rashi data
 */
export const getRashiByIndex = (index) => {
  return RASHI_DATA[index % 12];
};

/**
 * Get Nakshatra by name
 * @param {string} name - Nakshatra name
 * @returns {Object|undefined} Nakshatra data
 */
export const getNakshatraByName = (name) => {
  return NAKSHATRA_DATA.find(n => n.name.toLowerCase() === name.toLowerCase());
};

/**
 * Get Rashi by English name
 * @param {string} englishName - English name of rashi
 * @returns {Object|undefined} Rashi data
 */
export const getRashiByEnglishName = (englishName) => {
  return RASHI_DATA.find(r => r.english.toLowerCase() === englishName.toLowerCase());
};

/**
 * Get all Nakshatra names
 * @returns {Array<string>} Array of nakshatra names
 */
export const getAllNakshatraNames = () => {
  return NAKSHATRA_DATA.map(n => n.name);
};

/**
 * Get Nakshatra span in degrees
 * @returns {number} Nakshatra span (13.333... degrees)
 */
export const getNakshatraSpan = () => {
  return 360 / 27; // 13.3333... degrees
};

/**
 * Get Pada span in degrees
 * @returns {number} Pada span (3.333... degrees)
 */
export const getPadaSpan = () => {
  return getNakshatraSpan() / 4; // 3.3333... degrees
};
